import React, { useEffect, useState } from "react";
import { Dropdown, Modal, Nav, Tab } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import {
  get_CategoryRedirect,
  get_CategoryRedirect_Single_Data,
} from "../../../store/actions/CommanAction";
import swal from "sweetalert";
import { AddUpdate } from "../../../ApiMethods/ApiMethods";
import DataTable from "react-data-table-component";
import { customStyles } from "../Utility/Utility";
import Loader from "../Loader/Loader";

const RedirectCategory = () => {
  const dispatch = useDispatch();
  const CategoryNotificationData = useSelector(
    (state) => state.feedBackReducer.CategoryRedirectData
  );

  const CategoryNotificationSingleData = useSelector(
    (state) => state.feedBackReducer.CategoryRedirectSingleData
  );

  const customerID = Number(sessionStorage.getItem("ID"));

  const [IsActive, setIsActive] = useState(true);
  const [postModal, setPostModal] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [EditValue, setEditValue] = useState("");
  const [PushNotificationCategoryID, setPushNotificationCategoryID] =
    useState("");
  const [loading, setloading] = useState(false);
  const [addFormData, setaddFormData] = useState({
    Name: "",
    CreatedByUser: "1",
  });

  const Reset = () => {
    setaddFormData({ ...addFormData, Name: "" });
  };

  useEffect(() => {
    if (CategoryNotificationSingleData) {

      setEditValue(CategoryNotificationSingleData);
    }
  }, [CategoryNotificationSingleData]);

  useEffect(() => {
    if (IsActive) {
      dispatch(get_CategoryRedirect("1", setloading));
    } else {
      dispatch(get_CategoryRedirect("0", setloading));
    }
  }, [IsActive, IsActive]);

  useEffect(() => {
    if (EditValue && EditValue.length > 0) {

      setaddFormData({
        ...addFormData,
        Id: PushNotificationCategoryID,
        Name: EditValue[0]?.Name,
        ModifiedByUser: "1",
      });
    }
  }, [EditValue]);


  const handleAddFormSubmit = async (event) => {
    event.preventDefault();
    let error = false;
    let errorMsg = "";
    let trimCategory = addFormData?.Name.trim();
    if (!trimCategory) {
      error = true;
      errorMsg = "Please fill Skill.";
    }
    if (!error) {
      const newCustomerStory = { Name: addFormData.Name };

      await AddUpdate(
        "NotificationRedirect/Insert_NotificationRedirect",
        newCustomerStory
      );
      setPostModal(false);
      dispatch(get_CategoryRedirect(IsActive, setloading));
      swal("Good job!", "Successfully Added", "success");
      Reset();
      setaddFormData({ Name: "" });
    } else {
      swal("Oops", errorMsg, "error");
    }
  };

  const UpdateSlider = async (event) => {
    event.preventDefault();
    let error = false;
    let errorMsg = "";
    let trimCategory = addFormData?.Name.trim();
    if (!trimCategory) {
      error = true;
      errorMsg = "Please fill Skill.";
    }
    if (!error) {
      await AddUpdate(
        "NotificationRedirect/UpDate_NotificationRedirect",
        addFormData
      );
      setEditModal(false);
      dispatch(get_CategoryRedirect(IsActive, setloading));
      swal("Good job!", "Successfully update", "success");
      Reset();
      setaddFormData({ Name: "" });
    } else {
      swal("Oops", errorMsg, "error");
    }
  };

  const handleAddFormChange = (e) => {
    setaddFormData({ ...addFormData, [e.target.name]: e.target.value });
  };

  const handleEditClick = (row) => {


    dispatch(
      get_CategoryRedirect_Single_Data(row?.Id)
    );
    setPushNotificationCategoryID(row?.Id);
    setEditModal(true);
  };

  const columns = [
    {
      name: "Category",
      selector: (row) => row.Name,
      sortable: true,
    },
    {
      name: (
        <p
          className="text-end"
          style={{ position: "absolute", top: "7px", right: 50 }}
        >
          Action
        </p>
      ),
      cell: (row) => (
        <div style={{ position: "absolute", top: 4, right: 50 }}>
          <Dropdown>
            <Dropdown.Toggle variant="" as="div" className="btn-link i-false">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z"
                  stroke="#342E59"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6Z"
                  stroke="#342E59"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20Z"
                  stroke="#342E59"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </Dropdown.Toggle>
            <Dropdown.Menu alignRight={true} className="dropdown-menu-right">
              <Dropdown.Item onClick={() => handleEditClick(row)}>
                Edit
              </Dropdown.Item>
              <Dropdown.Item
                className={row.IsActive ? "text-danger" : "text-success"}
                onClick={() => {
                  handleToggleStatusClick(
                    row.Id,
                    true,
                    "0"
                  );
                }}
              >
                Inactive
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      ),
    },
  ];

  const columns1 = [
    {
      name: "Category",
      selector: (row) => row.Name,
      sortable: true,
    },
    {
      name: (
        <p
          className="text-end"
          style={{ position: "absolute", top: "7px", right: 0 }}
        >
          Action
        </p>
      ),
      cell: (row) => (
        <>
          <div style={{ position: "absolute", top: 4, right: 5 }}>
            <Dropdown>
              <Dropdown.Toggle variant="" as="div" className="btn-link i-false">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z"
                    stroke="#342E59"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6Z"
                    stroke="#342E59"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20Z"
                    stroke="#342E59"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </Dropdown.Toggle>
              <Dropdown.Menu alignRight={true} className="dropdown-menu-right">
                <Dropdown.Item
                  className={row.IsActive ? "text-danger" : "text-success"}
                  onClick={() => {
                    handleToggleStatusClick(
                      row.ID,
                      false,
                      "1"
                    );
                  }}
                >
                  Active
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </>
      ),
    },
  ];

  const handleToggleStatusClick = async (
    PushNotificationCategoryID,
    currentStatus,
    isActiveValue
  ) => {
    const postData = {
      Id: PushNotificationCategoryID,
      DeleteByUser: customerID,
      IsActive: isActiveValue,
    };
    await AddUpdate(
      "NotificationRedirect/Delete_NotificationRedirect",
      postData
    );
    dispatch(get_CategoryRedirect(currentStatus ? "1" : "0", setloading));
    swal(
      "Good job!",
      `Successfully ${isActiveValue === "1" ? "Active" : "Inactive"}`,
      "success"
    );
  };

  return (
    <>
      <h2 style={{ color: '#f7931e', fontWeight: 700 }}>Notification Rules Category </h2>
      <Tab.Container defaultActiveKey="All">
        <div className="mt-4 d-flex justify-content-between align-items-center flex-wrap main_card">
          <div className="card-action coin-tabs ">
            <Nav as="ul" className="nav nav-tabs" role="tablist">
              <Nav.Item as="li" className="nav-item">
                <Nav.Link
                  className="nav-link"
                  eventKey="All"
                  onClick={(currentStatus) => {
                    setIsActive(true);
                  }}
                >
                  Active
                </Nav.Link>
              </Nav.Item>
              <Nav.Item as="li" className="nav-item">
                <Nav.Link
                  className="nav-link"
                  eventKey="Inactive"
                  onClick={(currentStatus) => {
                    setIsActive(false);
                  }}
                >
                  Inactive
                </Nav.Link>
              </Nav.Item>
            </Nav>
          </div>
          <Link
            to={"#"}
            className="btn btn-primary font-w600 "
            onClick={() => {
              setPostModal(true);
              Reset();
            }}
          >
            + New Category
          </Link>
        </div>
        <div className="row">
          <div className="col-xl-12">
            <div className="">
              <div className=" p-0">
                <Tab.Content>
                  <Tab.Pane eventKey="All">
                    <div className="mb-sm-5 d-flex flex-wrap align-items-center text-head">
                      <Modal
                        className="modal fade"
                        show={postModal}
                        onHide={() => setPostModal(false)}
                        backdrop="static"
                      >
                        <form>
                          <div className="modal-header">
                            <h4 className="modal-title fs-20">
                              Add Notification
                            </h4>
                            <button
                              type="button"
                              className="btn-close"
                              onClick={() => setPostModal(false)}
                              data-dismiss="modal"
                            ></button>
                          </div>
                          <div className="modal-body p-3">
                            <i
                              className="flaticon-cancel-12 close"
                              data-dismiss="modal"
                            ></i>
                            <div className="add-contact-box">
                              <div className="add-contact-content">
                                <div className="d-flex align-items-center">
                                  <label htmlFor="">Notification</label>
                                  <span className="text-danger star-error">
                                    *
                                  </span>
                                </div>
                                <div className="form-group">
                                  <input
                                    type="text"
                                    // className="form-control"
                                    autoComplete="off"
                                    name="Name"
                                    required="required"
                                    value={addFormData?.Name}
                                    onChange={handleAddFormChange}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="modal-footer">
                            <button
                              type="submit"
                              className="btn btn-primary"
                              onClick={handleAddFormSubmit}
                            >
                              Save
                            </button>
                            <button
                              type="button"
                              onClick={() => {
                                setPostModal(false);
                                Reset();
                              }}
                              className="btn btn-danger"
                            >
                              <i className="flaticon-delete-1"></i> Close
                            </button>
                          </div>
                        </form>
                      </Modal>
                    </div>
                    <Modal
                      className="modal fade "
                      show={editModal}
                      onHide={setEditModal}
                      backdrop="static"
                    >
                      <div className="" role="document">
                        <div className="">
                          <form>
                            <div className="modal-header">
                              <h4 className="modal-title fs-20">
                                Edit Notification
                              </h4>
                              <button
                                type="button"
                                className="btn-close"
                                onClick={() => setEditModal(false)}
                                data-dismiss="modal"
                              ></button>
                            </div>
                            <div className="modal-body p-3">
                              <i
                                className="flaticon-cancel-12 close"
                                data-dismiss="modal"
                              ></i>
                              <div className="add-contact-box">
                                <div className="add-contact-content">
                                  <label htmlFor="">Notification</label>
                                  <span className="text-danger star-error">
                                    *
                                  </span>
                                  <input
                                    type="text"
                                    className="form-control"
                                    autoComplete="off"
                                    name="Name"
                                    required="required"
                                    value={addFormData?.Name}
                                    onChange={handleAddFormChange}
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="modal-footer">
                              <button
                                type="submit"
                                className="btn btn-primary"
                                onClick={UpdateSlider}
                              >
                                Update
                              </button>
                              <button
                                type="button"
                                onClick={() => {
                                  setEditModal(false);
                                  Reset();
                                }}
                                className="btn btn-danger"
                              >
                                {" "}
                                <i className="flaticon-delete-1"></i> Close
                              </button>
                            </div>
                          </form>
                        </div>
                      </div>
                    </Modal>
                    <div className="col-12 mt-2">
                      {loading ? (
                        <Loader />
                      ) : (
                        <DataTable
                          dense
                          data={CategoryNotificationData}
                          columns={columns}
                          selectableRowsHighlight
                          pagination
                          persistTableHead={true}
                          noDataComponent={"There are no data to display"}
                          customStyles={customStyles}
                        />
                      )}
                    </div>
                  </Tab.Pane>
                  <Tab.Pane eventKey="Inactive">
                    <div className="row">
                      <div className="col-12 mt-2">
                        {loading ? (
                          <Loader />
                        ) : (
                          <DataTable
                            dense
                            data={CategoryNotificationData}
                            columns={columns1}
                            selectableRowsHighlight
                            highlightOnHover
                            customStyles={customStyles}
                            pagination
                            fixedHeader
                            persistTableHead={true}
                            noDataComponent={"There are no data to display"}
                          />
                        )}
                      </div>
                    </div>
                  </Tab.Pane>
                </Tab.Content>
              </div>
            </div>
          </div>
        </div>
      </Tab.Container>
    </>
  );
};
export default RedirectCategory;
